export enum Roles {
  SuperAdmin = "SuperAdmin",  // Can manage all users and all modules. Only web app.
  CustomerAdmin = "CustomerAdmin", // For any of the 3 modules: Service, Process, Inventory. Can manage customers and customer offices. Only web app.
  ProcessAdmin = "ProcessAdmin", // For Process module. Can manage users for process and process customer. Can see all processes. Can't create or edit processes. Only web app.
  ProcessOffice = "ProcessOffice", // For Process module. Can create and edit process office. Can see all office's processes. Only web app.
  ProcessCustomer = "ProcessCustomer", // For Process module. Can create and edit process customer. Can see only own office's processes. Only web app.
  ProcessCustomerAdmin = "ProcessCustomerAdmin", // For Process module. Can manage users for process customer. Can see all process customers. Can't create or edit process customers. Only web app.
  ProcessTechnician = "ProcessTechnician", // For Process module. Creates the entry for the process. Only mobile user app.
  Service = "Service", // For Service module. Can create and edit service. Can see only own office's services. Only web app.
  ServiceOverview = "ServiceOverview", // For Service module. Can see all services. Only web app.
  ServiceAdmin = "ServiceAdmin", // For Service module. Can manage users for service. Can see all services. Can't create or edit services. Only web app.
  ServiceCustomer = "ServiceCustomer", // For Service module. Can create and edit service customer. Can see only own office's services. Only web app.
  InventoryAdmin = "InventoryAdmin", // For Inventory module. Can manage users for inventory. Can see all inventories. Can't create or edit inventories. Only web app.
  InventoryManager = "InventoryManager", // For Inventory module. Can manage inventories. Only web app.
  InventoryRecorder = "InventoryRecorder", // For Inventory module. Can record cars in inventory. Only mobile user app.
  InventoryAuditor = "InventoryAuditor", // For Inventory module. Can audit cars in inventory. Only mobile user app.
}

export const rolesGermanLabels: Record<Roles, string> = {
  [Roles.SuperAdmin]: "SuperAdmin",
  [Roles.CustomerAdmin]: "Kundenverwaltung",
  [Roles.ProcessAdmin]: "Prozessverwaltung",
  [Roles.ProcessOffice]: "Prozess",
  [Roles.ProcessCustomer]: "Prozesskunde",
  [Roles.ProcessCustomerAdmin]: "Prozesskundenverwaltung",
  [Roles.ProcessTechnician]: "Prozesstechniker",
  [Roles.Service]: "Serviceleistung",
  [Roles.ServiceOverview]: "Service Übersicht",
  [Roles.ServiceAdmin]: "Serviceverwaltung",
  [Roles.ServiceCustomer]: "Servicekunde",
  [Roles.InventoryAdmin]: "Inventurverwaltung",
  [Roles.InventoryManager]: "Inventurverantwortlicher",
  [Roles.InventoryRecorder]: "Inventurfasser",
  [Roles.InventoryAuditor]: "Inventurprüfer",
};

export const toGermanRoleLabel = (role: string): string => {
  if (Object.values(Roles).includes(role as Roles)) {
    return rolesGermanLabels[role as Roles];
  }

  return role;
};

